module.exports = __webpack_public_path__ + "static/img/bg-id.4ea7c955.png";